<template>
  <div>
    <div class="content">
      <v-app>
        <v-content>
          <v-container>
            <div>
              <div class="my-4 text-h4 mx-2">{{ name }} 隐私政策</div>

              <div style="padding: 10px 0 10px 25px">
                <div>
                  政策发布时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2026-08-05
                </div>
                <div>
                  最近更新时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2026-08-05
                </div>
                <div>更新版本生效时间：&nbsp;&nbsp;2026-08-05</div>
              </div>

              <div style="height: 20px"></div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                欢迎您访问我们的产品。
                <strong>{{ name }}</strong>（包括手机APP、网站、小程序等产品提供的服务，以下简称“产品和服务”）是由
                <strong>湖南大湘速聘信息科技有限公司</strong>（以下简称“我们”）开发并运营的。
                确保用户的数据安全和隐私保护是我们的首要任务，
                本隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，
                一旦您选择使用，即视为您同意本隐私政策的全部内容，同意我们按其收集和使用您的相关信息。
                如在阅读过程中对本政策有任何疑问，可联系我们的客服咨询，请通过
                <strong>{{ email }}</strong> 或产品中的反馈方式与我们取得联系。
                如您不同意相关协议或其中的任何条款，您应停止使用我们的产品和服务。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                本隐私政策帮助您了解以下内容：
                <div class="mt-2">一、定义；</div>
                <div>二、我们如何收集和使用您的个人信息；</div>
                <div>三、我们如何存储和保护您的个人信息；</div>
                <div>四、我们如何共享、转让、公开披露您的个人信息；</div>
                <div>五、权限调用说明；</div>
                <div>六、第三方SDK调用说明；</div>
                <div>七、本政策如何更新；</div>
                <div>八、如何联系我们；</div>
              </div>

              <!-- 一、定义 -->
              <div class="text-h6 mb-4">一、定义</div>

              <div class="text-muted" style="text-indent: 2em">
                <strong>我们：</strong>指湖南大湘速聘信息科技有限公司。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人信息：</strong>指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人敏感信息：</strong>指一旦泄露或者非法使用，可能导致个人受到歧视或者人身、财产受到严重危害的个人信息，包括种族、民族、宗教信仰、个人生物特征、医疗健康、金融账户、个人行踪等信息（本政策中对具体个人敏感信息以<strong>粗体</strong>进行显著标识）。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>未成年人：</strong>指不满十八周岁的自然人。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                <strong>儿童：</strong>指不满十四周岁的自然人。
              </div>

              <!-- 二、收集和使用 -->
              <div class="text-h6 mb-4">二、我们如何收集和使用您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》和《信息安全技术 个人信息安全规范》（GB/T
                35273-2020）以及其他相关法律法规的要求，严格遵循正当、合法、必要的原则，
                出于为您提供产品和服务的需要收集和使用您的个人信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为接受我们全面的产品服务，您应首先注册一个用户账号。您所提供的账户名、密码、联系方式等信息，
                将在注册过程中由您主动提交。我们可能通过发送短信或邮件的方式验证您的身份是否有效。
              </div>

              <!-- 三、存储和保护 -->
              <div class="text-h6 mb-4">三、我们如何存储和保护您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                作为一般规则，我们仅在实现信息收集目的所需的时间内保留您的个人信息。
                出于管理与您之间关系的必要，我们会保留账户及相关业务数据。
                如需遵守法律义务或满足法定时效要求，我们可能在上述期限到期后继续留存相关信息，并依法采取安全保护措施。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为加强对隐私数据的保护，我们在收集时对敏感信息进行脱敏处理，
                在我们的生产环境中原则上不会存储可还原的明文隐私数据。
              </div>

              <!-- 四、共享、转让、公开披露 -->
              <div class="text-h6 mb-4">四、我们如何共享、转让、公开披露您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                除本政策及法律法规另有规定外，我们不会主动向第三方共享您的个人信息。
                仅在合法合规前提下，根据政府主管部门的强制性要求（如传票、调查函等）提供相关信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
                <div class="mt-2">
                  1、与国家安全、国防安全直接相关的；<br />
                  2、与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />
                  3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                  4、您自行向社会公众公开的个人信息；<br />
                  5、从合法公开披露的信息中收集的个人信息；<br />
                  6、根据个人信息主体要求签订和履行合同所必需的；<br />
                  7、用于维护产品或服务安全稳定运行所必需的，如发现、处置故障；<br />
                  8、法律法规规定的其他情形。
                </div>
              </div>

              <!-- 五、权限调用 -->
              <div class="text-h6 mb-4">五、权限调用说明</div>

              <ul style="padding:0 0 0 20px" class="text-muted">
                <li>
                  <strong>相机权限</strong>：在您使用拍照、扫码等功能时，经您授权后调用。
                </li>
                <li>
                  <strong>相册权限</strong>：在您上传或保存图片时，经您授权后调用。
                </li>
                <li>
                  <strong>蓝牙权限</strong>：在您连接蓝牙设备时，经您授权后调用。
                </li>

                <!-- ✅ 新增：传感器 -->
                <li>
                  <strong>传感器权限</strong>：为提升服务稳定性与用户体验，在经您授权后，我们可能会调用设备中的部分传感器：
                  <ul style="padding-left: 20px;">
                    <li>
                      <strong>加速度传感器 / 陀螺仪</strong>：
                      用于识别设备运动状态，优化推送链路稳定性、页面交互体验及异常行为风控。
                    </li>
                    <li>
                      <strong>距离（接近）传感器</strong>：
                      在特定交互场景下自动关闭屏幕或调整界面展示。
                    </li>
                    <li>
                      <strong>光线传感器</strong>：
                      根据环境亮度自适应调整界面显示效果。
                    </li>
                  </ul>
                  上述传感器数据仅在设备本地处理，不会用于用户画像或广告推荐，也不会上传至服务器。
                </li>

                <li>
                  <strong>应用检测更新说明</strong>：为向您提供最新版本，我们会在后台检测更新并提醒您升级。
                </li>
              </ul>

              <!-- 六、第三方 SDK -->
              <div class="text-h6 mb-4">六、第三方 SDK 调用说明</div>

              <p class="text-muted"><strong>合作方：极光推送（JPush / JCore）</strong></p>
              <p class="text-muted">合作目的：为 App 用户提供稳定、可靠的信息推送服务。</p>

              <p class="text-muted"><strong>处理个人信息类型及用途：</strong></p>
              <ul style="padding:0 0 0 20px" class="text-muted">
                <li>
                  <strong>设备标识符</strong>（Android ID、OAID、GAID、IDFA 等）：
                  用于生成设备唯一标识，保障推送准确性。
                </li>
                <li>
                  <strong>设备硬件信息</strong>（设备型号、分辨率、厂商等）：
                  用于推送服务兼容性优化。
                </li>
                <li>
                  <strong>操作系统信息</strong>（系统版本、语言、系统名称）：
                  用于推送服务适配。
                </li>
                <li>
                  <strong>网络信息</strong>（网络类型、IP、运营商、Wi-Fi 状态）：
                  用于选择最优推送节点。
                </li>
                <li>
                  <strong>设备传感器信息</strong>（加速度传感器、陀螺仪等）：
                  用于提升推送链路稳定性与送达率，判断设备运行状态。
                </li>
                <li>
                  <strong>推送日志信息</strong>：
                  用于统计推送到达率与点击情况。
                </li>
              </ul>

              <p class="text-muted">
                <strong>数据处理方式：</strong>采用去标识化、加密传输等安全措施。
              </p>

              <p class="text-muted">
                <strong>极光隐私政策：</strong>
                <a href="https://www.jiguang.cn/privacy.html" target="_blank">
                  《AURORA 极光隐私政策》
                </a>
              </p>

              <p class="text-muted">
                <strong>官网：</strong>
                <a href="https://www.jiguang.cn/" target="_blank">
                  https://www.jiguang.cn/
                </a>
              </p>

              <!-- 七、政策更新 -->
              <div class="text-h6 mb-4">七、本政策如何更新</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的隐私政策可能适时变更。未经您明确同意，我们不会削减您在本政策项下应享有的权利。
                本政策更新后，我们将在本页面发布最新版本，并在发生重大变更时通过站内通知、弹窗、短信或邮件等方式告知您。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                本政策所指的重大变更包括但不限于：
                <div class="mt-2">
                  1、服务模式发生重大变化；<br />
                  2、公司组织结构或所有权发生变更；<br />
                  3、个人信息共享、转让或公开披露的对象发生变化；<br />
                  4、您行使个人信息权利的方式发生重大变化；<br />
                  5、个人信息保护负责人或投诉渠道发生变化；<br />
                  6、经安全评估表明存在高风险的其他情形。
                </div>
              </div>

              <!-- 八、联系我们 -->
              <div class="text-h6 mb-4">八、如何联系我们</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                如您对本政策有任何疑问、意见或建议，可通过以下方式联系我们：
                <div class="mt-2">
                  （1）电子邮件：{{ email }}<br />
                  （2）联系地址：湖南省长沙市岳麓区望城坡街道枫林三路49号换乘大楼101一楼南侧105，联系人：前台
                </div>
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的客服及个人信息保护专职部门将在收到您请求后的 30 天内予以回复并处理。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                如您对我们的处理结果不满意，可向湖南大湘速聘信息科技有限公司所在地人民法院提起诉讼，
                或向网信、市场监管、公安等监管部门投诉举报。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">（完）</div>
            </div>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "admin@daxiangsys.com"
    };
  },
  mounted() {
    const query = this.$route.query;
    this.name = query.name || "大象系统";
  }
};
</script>

<style scoped>
.content {
  padding: 20px;
}
.text-muted {
  color: rgba(0, 0, 0, 0.6);
}
</style>